import { BumperSticker, Sticker } from '@/model/printType/printTypes';

export const getIsStickerByPrintType = (configPrintTypeId: string) => {
  return [Sticker, BumperSticker].includes(configPrintTypeId);
};
